var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.841,
    height: 37.994,
    viewBox: "0 0 27.841 37.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_87674",
    "data-name": "Path 87674",
    d: "M39.267,26.577l-22.425-16.3a2.7,2.7,0,0,0-4.295,2.181V45.049a2.7,2.7,0,0,0,1.477,2.411,2.723,2.723,0,0,0,1.229.291,2.688,2.688,0,0,0,1.588-.525L39.267,30.94a2.683,2.683,0,0,0,0-4.363Z",
    transform: "translate(-12.547 -9.758)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.7c059960ec91085d8698f4020f02c4d2.svg";
export { ForwardRef as ReactComponent };